import axios from "axios";
import { gettoken } from "../token/token";
import apiurl from "../apiendpoint/apiendpoint";
import { decryptData } from "../encryption";

export const apigetallHomePyqs = async (params) => {
    try {
        const token = gettoken();
        const res = await axios.get(`${apiurl()}/pyq/getHomepyqs`,{params:params,headers: { "Authorization": `Bearer ${token}` }});
        return res.data;
    } catch (err) {
        console.log(err);
    }
};

export const apigetHomePyqDetails = async (slug) => {
    try {
        const token = gettoken();
        const res = await axios.get(`${apiurl()}/pyq/getHomePyqsDetails`,{params:{slug: slug },headers: { "Authorization": `Bearer ${token}` }});
        return res.data;
    } catch (err) {
        console.log(err);
    }
};

export const apigetHomePyqData = async (slug, sectionId) => {
    try {
        const token = gettoken();
        const res = await axios.get(`${apiurl()}/pyq/getHomemainPyqData`,{params:{slug: slug, sectionId: sectionId  },headers: { "Authorization": `Bearer ${token}` }});
        // if (res.data.encrypted && res.data.data) {
        //     const decryptedData = decryptData(res.data.data);
        //     return { resdata: decryptedData };
        // }
        return res.data;
    } catch (err) {
        console.log(err);
    }
};

export const apigetPyqPdf = async (pyqId, sectionId, mediaIndex) => {
    try {
        const token = gettoken();
        const res = await axios.get(`${apiurl()}/pyq/apigetpyqpdf`, {
            params: { _id: pyqId, sectionId: sectionId, mediaIndex: mediaIndex },
            headers: { "Authorization": `Bearer ${token}` },
            responseType: 'blob'
        });
        return res.data;
    } catch (err) {
        console.log(err);
        throw err;
    }
};

export const apigetHomePyqsByCategory = async (params) => {
    try {
        const token = gettoken();
        const res = await axios.get(`${apiurl()}/pyq/getHomepyqsByCategory`,{params:params,headers: { "Authorization": `Bearer ${token}` }});
        return res.data;
    } catch (err) {
        console.log(err);
    }
};